import Reveal from "@/components/feature/Reveal";

export default function PhotoBand() {
  return (
    <section className="w-full bg-background-100">
      <Reveal className="mx-auto max-w-[1400px] px-4 py-14 md:px-8 md:py-20">
        <figure className="relative overflow-hidden rounded-lg border border-foreground-900/10">
          <div className="h-[260px] w-full md:h-[420px]">
            <img
              src="https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20school%20campus%20courtyard%20at%20dusk%20seen%20from%20above%2C%20warm%20cream%20paper%20tones%20with%20amber%20street%20lamps%20and%20terracotta%20roof%20accents%2C%20muted%20grainy%20magazine%20texture%2C%20calm%20atmospheric%20mood%2C%20no%20text%2C%20no%20faces%2C%20flat%20artistic%20composition%2C%20consistent%20warm%20palette&width=1600&height=820&seq=campus-file-band-01&orientation=landscape"
              alt="校园黄昏影像，黑料学生校内传闻纪实"
              className="h-full w-full object-cover object-top"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/20 to-transparent" />
          <figcaption className="absolute bottom-0 left-0 w-full p-5 md:p-8">
            <p className="text-[11px] tracking-[0.28em] text-background-50/80">影像纪实 · 01</p>
            <p className="mt-2 max-w-2xl font-heading text-lg font-bold leading-snug text-background-50 md:text-2xl">
              黄昏里的校园：很多传闻都发生在这条路上，而真相往往藏在第二天的通报里
            </p>
          </figcaption>
        </figure>
      </Reveal>
    </section>
  );
}